module.exports = __webpack_public_path__ + "un.svg?424ca4dfb83e20505d9c5a92f107b151";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/un.svg
// module id = 1466
// module chunks = 0